import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b8781e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choice-space" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "位置:", -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "search-space" }
const _hoisted_6 = { class: "com-select" }
const _hoisted_7 = { class: "search-icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "space-content" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "space-item" }
const _hoisted_12 = { class: "item-text" }
const _hoisted_13 = {
  key: 1,
  class: "no-data",
  height: "100%",
  width: "100%"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_16 = {
  key: 0,
  class: "next-btn-box"
}
const _hoisted_17 = { class: "space-type" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_tree_select = _resolveComponent("van-tree-select")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "search-floor",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPounp && _ctx.showPounp(...args)))
      }, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.checkPositon.buildingName) + _toDisplayString(_ctx.checkPositon.floorName), 1),
        _createVNode(_component_van_icon, {
          class: "arrow-down",
          name: "arrow-down"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "com-text",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showSpaceTypePounp && _ctx.showSpaceTypePounp(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.spaceType.name), 1),
            _createVNode(_component_van_icon, {
              class: "arrow-down",
              name: "arrow-down"
            })
          ])
        ]),
        _createVNode(_component_van_search, {
          class: "search-box",
          modelValue: _ctx.searchSpaceName,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchSpaceName) = $event)),
            _ctx.searchSpace
          ],
          placeholder: "请输入搜索关键词"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _ctx.parseImgUrl('search-icon', 'search-icon.svg'),
            alt: ""
          }, null, 8, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.showSpace)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.spaceData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "space-box",
              id: 'space' + index,
              key: 'space' + index
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.spaceName), 1),
                _createVNode(_component_van_checkbox, {
                  class: "item-check",
                  modelValue: item.checked,
                  "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                  onClick: ($event: any) => (_ctx.updateWorkSpace(item)),
                  shape: "square"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
              ])
            ], 8, _hoisted_10))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("img", {
              src: _ctx.parseImgUrl('page-officehome', 'empty.png'),
              alt: ""
            }, null, 8, _hoisted_14),
            _hoisted_15
          ]))
    ]),
    (_ctx.spaceData && _ctx.spaceData.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goNext && _ctx.goNext(...args)))
          }, "下一步")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.show) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tree_select, {
          onClickNav: _ctx.checkBuilding,
          onClickItem: _ctx.checkFloor,
          "active-id": _ctx.checkPositon.floorId,
          "onUpdate:active-id": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkPositon.floorId) = $event)),
          "main-active-index": _ctx.activeIndex,
          "onUpdate:main-active-index": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeIndex) = $event)),
          items: _ctx.positionArr
        }, null, 8, ["onClickNav", "onClickItem", "active-id", "main-active-index", "items"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showSpaceType,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showSpaceType) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spaceTypeArr, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              onClick: ($event: any) => (_ctx.checkSpaceType(item)),
              class: _normalizeClass(_ctx.spaceType.type === item.type ? 'active-type' : ''),
              key: 'space-type-id' + index
            }, _toDisplayString(item.name), 11, _hoisted_18))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}